import { useEffect, useRef } from "preact/hooks";
import assets, { getDay } from "../assets";
import GRID from "../components/GRID";
import { achievement } from "../utils";
import { BackToAtrium } from "./breakouts";

export default {
    background: assets.interviews.df,
    links: [
        {
            ...BackToAtrium,
            top: "91.7%",
            left: "43.9%"
        },
        {
            top: "73.7%",
            left: "42%",
            width: "16.2%",
            height: "8.3%",
            onClick() {
                window.open(assets.interviews.CTA)
            }
        }
    ],
    showNavbar: false,
    extras: assets.interviews.GRID.map(grid => <GRID {...grid} roomName="interviews" modalContent={(link, row) => () => {
        const day = getDay()
        const ref = useRef(null)
        const triggered = useRef(false)

        useEffect(() => {
            const player = new Vimeo.Player(ref.current)

            player.on("timeupdate", it => {
                
                if (it.percent <= .95 || triggered.current || day !== 2) return;
                achievement(link[2])
                triggered.current = true
            })
        }, [])

        return <iframe ref={ref} src={link[1]} allow="autoplay" style={{
            border: 0,
            borderRadius: "16px",
            width: "66em",
            marginTop: "22px",
            aspectRatio: "16/9"
        }} />
    }}/>),
    name: "interviews"
}